import { Close, AddHomeWorkOutlined } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, Divider, IconButton, Stack, Typography } from "@mui/material";
import PhysicalUnitDefinitionFields from "components/forms/installations/PhysicalUnitDefinitionFields";
import { CommunityContext } from "contexts/communities/CommunityContext";
import { useUserFeedbackContext } from "contexts/UserFeedbackContext";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

const CreatePhysicalUnitInlineDialog = ({ open, onClose, onComplete }) => {

    const { t } = useTranslation();
    const { createPhysicalUnit } = useContext(CommunityContext);
    const { setAndShowErrorMessage } = useUserFeedbackContext();
    const [submitting, setSubmitting] = useState(false);

    const handleComplete = (values) => {
        setSubmitting(true);
        createPhysicalUnit(values).then((response) => {
            setSubmitting(false);
            onComplete(response.data);
        }).catch((e) => {
            setSubmitting(false);
            console.error(e);
            setAndShowErrorMessage(e);
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
                <Stack spacing={2} direction="row" alignItems="center">
                    <IconButton onClick={onClose}>
                        <Close />
                    </IconButton>
                    <AddHomeWorkOutlined color="primary" />
                    <Typography variant="subtitle1" color="textPrimary">{t("label.button.createInstallation")}</Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Divider fullWidth sx={{ mb: 2 }} />
                <PhysicalUnitDefinitionFields onComplete={handleComplete} onCancel={onClose} submitting={submitting} />
            </DialogContent>
        </Dialog>
    );
};

export default CreatePhysicalUnitInlineDialog;